import { memo as Memo, useMemo } from 'react'

//* Helper
import config from 'helpers/_config'

//* Components
import Text from 'components/common/Text'
import CustomLink from 'components/common/CustomLink'

const FooterMenu = Memo(({}) => {
	//! Footer menu store
	const footerMenuStore = useMemo(() => {
		return Object.entries(config.routes).map((route, ind) => {
			if (route[1].inFooter) {
				return (
					<CustomLink
						key={ind}
						url={route[1].path}
						className={`f-menu-item hover-line`}
					>
						<Text
							tag={'p'}
							className={`p p4 notoSans-medium primary-color9`}
							text={route[1].name}
						/>
					</CustomLink>
				)
			}
		})
	}, [])

	return footerMenuStore
})

export default FooterMenu
